class Checkout
{
    constructor() {
        this.createPopup();
        this.handlePopup();
    }

    handlePopup() {
        const popup = document.querySelector("#latam-popup-about");
        popup.addEventListener("click", () => {
            popup.classList.remove("latam-popup-about-active");
        });
    }

    createPopup() {

        const hidden = document.querySelector("#latam-info-banner");

        const div = document.createElement("div");
        div.setAttribute("id", "latam-popup-about");
        div.classList.add("latam-popup-about");

        const span = document.createElement("span");
        span.setAttribute("id", "latam-close-popup");
        span.innerHTML = "&times;";
        span.classList.add("close");

        const img = document.createElement("img");
        if ( hidden && hidden.value ) {
            img.setAttribute("src", hidden.value);
        } else {
            img.setAttribute("src", "");
        }

        div.appendChild(span);
        div.appendChild(img);

        const body = document.querySelector("body");
        body.appendChild(div);

    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Checkout;
});